import { createFileRoute } from "@tanstack/react-router"
import { UserAgreementPage } from "~/features/user-agreement/components/user-agreement-page"

export const Route = createFileRoute("/profile/user-agreement")({
  component: UserAgreementPage,
})
